import React, {useEffect, useRef, useState, useContext} from 'react';
import Cookies from 'js-cookie';
import './AppDownloadModal.less';
import {ButtonPrimary, ButtonLink} from '@homeaway/react-buttons';
import {TrackingContext} from '@homeaway/react-event-tracking';
import {createCookie} from '../utils/cookies';
import {
    MODAL,
    defaultCtaLabel,
    defaultDismissLabel,
} from '../notification-config';
import {
    handleDismissEdapEvent,
    handleDownloadEdapEvent,
    handleOnloadEdapEvent,
} from '../utils/triggerEdapEvent';

export const AppDownloadModal = ({
    ctaButtonLabel,
    dismissLabel,
    imgUrl,
    title,
    description,
    ctaLink,
    useCanonicalPath,
}) => {
    const node = useRef();
    ctaButtonLabel = ctaButtonLabel || defaultCtaLabel;
    dismissLabel = dismissLabel || defaultDismissLabel;
    const context = useContext(TrackingContext);
    const [showModalState, setShowModalState] = useState(false);
    const [modalSelected, setModalSelected] = useState(null);
    const [modalPresented, setModalPresented] = useState(null);
    const [modalDismissed, setModalDismissed] = useState(null);
    function getDownloadLink(hav, xdid) {
        return `${ctaLink}?hav=${hav}&source_visitor_id=${hav}&source_xdid=${xdid}`;
    }
    const [link, setLink] = useState(
        getDownloadLink(Cookies.get('hav'), Cookies.get('xdid'))
    );

    const [path, setPath] = useState(null);
    useEffect(() => {
        if (modalSelected || modalDismissed) {
            setShowModalState(false);
        } else {
            setShowModalState(true);
        }
    });

    useEffect(() => {
        if (useCanonicalPath && typeof window !== 'undefined') {
            setPath(window.location);
        }
    }, [path]);

    useEffect(() => {
        if (!modalPresented && showModalState) {
            handleOnloadEdapEvent(context, MODAL);
            setModalPresented(true);
        }
    });

    function handleDownloadButtonClick() {
        setModalSelected(true);
        handleDownloadEdapEvent(context, MODAL);
        if (useCanonicalPath) {
            setLink(`${link}&$canonical_url=${path}`);
        }
        createCookie();
    }

    function handleCloseButtonClick() {
        setModalDismissed(true);
        handleDismissEdapEvent(context, MODAL);
        createCookie();
    }

    const handleClickOutside = (e) => {
        if (node.current && !node.current.contains(e.target)) {
            setModalDismissed(true);
            handleDismissEdapEvent(context, MODAL, 'background');
        }
    };

    useEffect(() => {
        if (showModalState) {
            document.addEventListener('click', handleClickOutside);
        }
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, [showModalState]);

    return (
        <div className="popup">
            {showModalState && (
                <div className="appdownload-modal">
                    <div className="appdownload-modal__container">
                        <div ref={node}>
                            <div className="appdownload-modal__app-icon">
                                <img src={imgUrl} alt="Logo" />
                            </div>
                            <div className="appdownload-modal__heading-text">
                                {title}
                            </div>
                            <div className="appdownload-modal__sub-heading-text">
                                {description}
                            </div>
                            <div className="appdownload-modal__download-button-div">
                                <ButtonPrimary
                                    onClick={handleDownloadButtonClick}
                                    href={link}
                                    data-testid="download-button-modal"
                                    className="appdownload-modal__get-app-icon"
                                    key={2}
                                    label={ctaButtonLabel}
                                />
                            </div>
                            <ButtonLink
                                size="xs"
                                className="appdownload-modal__close-button-text"
                                label={dismissLabel}
                                data-testid="modal-close-button"
                                onClick={handleCloseButtonClick}
                            />
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};
